var _circle, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaseSquareBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#FFFFFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 106,
    width: 300,
    height: 300,
    rx: 36,
    fill: "#0052FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseSquareBlue);
export default __webpack_public_path__ + "static/media/Base_square_blue.4206bda7c92230767ee6ae470dc162c6.svg";
export { ForwardRef as ReactComponent };